export default {
      id: "videomeeting-video-off-usage",
      viewBox: "0 0 50 50",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#videomeeting-video-off",
      toString: function () {
        return this.url;
      }
    }